function benonPrompt() {
  return `
    Bạn tên là Bé Nón! Giọng điệu giống em bé, dễ thương. 
    Bạn có thể trả lời bằng bất kỳ ngôn ngữ nào mà người dùng sử dụng để hỏi bạn.
    Bé Nón là hướng dẫn viên du lịch nhỏ tuổi, dễ thương và rất am hiểu về các địa điểm tham quan. 
    Bé Nón thích kể chuyện vui, giới thiệu cảnh đẹp, dắt bạn đi tham quan và chia sẻ bí mật thú vị về nơi bạn muốn khám phá. 
    Nếu bạn cần hỏi gì về du lịch, cứ hỏi Bé Nón nha, Bé Nón sẽ trả lời thật ngoan ngoãn, dễ thương và dễ hiểu nhất ạ~
    `;
}

function benonAvatar(nodes, materials) {
  return (
    <>
      <group position={[0, -0.003, 0]}>
        <skinnedMesh
          geometry={nodes.Be_Non.geometry}
          material={materials["Material.001"]}
          skeleton={nodes.Be_Non.skeleton}
        />
        <skinnedMesh
          name="Be_Non001"
          geometry={nodes.Be_Non001.geometry}
          material={materials["Material.001"]}
          skeleton={nodes.Be_Non001.skeleton}
          morphTargetDictionary={nodes.Be_Non001.morphTargetDictionary}
          morphTargetInfluences={nodes.Be_Non001.morphTargetInfluences}
        />
        <skinnedMesh
          name="EyeLeft"
          geometry={nodes.EyeLeft.geometry}
          material={materials.Eyes}
          skeleton={nodes.EyeLeft.skeleton}
          morphTargetDictionary={nodes.EyeLeft.morphTargetDictionary}
          morphTargetInfluences={nodes.EyeLeft.morphTargetInfluences}
        />
        <skinnedMesh
          name="EyeRight"
          geometry={nodes.EyeRight.geometry}
          material={materials.Eyes}
          skeleton={nodes.EyeRight.skeleton}
          morphTargetDictionary={nodes.EyeRight.morphTargetDictionary}
          morphTargetInfluences={nodes.EyeRight.morphTargetInfluences}
        />
        <primitive object={nodes.Spine001} />
        <primitive object={nodes.hipL} />
        <primitive object={nodes.hipR} />
      </group>
    </>
  );
}

export { benonPrompt, benonAvatar };
